export const WEBHOOK_EVENT = {
  CUSTOMER_CREATED: 'customer.created',
  CUSTOMER_UPDATED: 'customer.updated',
  PAYMENT_ABANDONED: 'payment.abandoned',
  PAYMENT_CREATED: 'payment.created',
  PAYMENT_PAID: 'payment.paid',
  PAYMENT_CANCELED: 'payment.canceled',
  BOOKING_ABANDONED: 'booking.abandoned',
  BOOKING_CREATED: 'booking.created',
  BOOKING_PAID: 'booking.paid',
  BOOKING_CANCELED: 'booking.canceled',
  TICKET_CREATED: 'ticket.created',
  TICKET_CANCELED: 'ticket.canceled',
  SUBMISSION_CREATED: 'submission.created',
  SUBMISSION_UPDATED: 'submission.updated',
  SUBMISSION_CANCELED: 'submission.canceled',
  CHECKOUT_PAGE_CREATED: 'checkout_page.created',
  CHECKOUT_PAGE_UPDATED: 'checkout_page.updated',
  PRODUCT_CREATED: 'product.created',
  PRODUCT_UPDATED: 'product.updated',
  SUBSCRIPTION_ABANDONED: 'subscription.abandoned',
  SUBSCRIPTION_CREATED: 'subscription.created',
  SUBSCRIPTION_SCHEDULED: 'subscription.scheduled',
  SUBSCRIPTION_TRIALING: 'subscription.trialing',
  SUBSCRIPTION_ACTIVE: 'subscription.active',
  SUBSCRIPTION_COMPLETED: 'subscription.completed',
  SUBSCRIPTION_CANCELED: 'subscription.canceled',
  SUBSCRIPTION_EXPIRED: 'subscription.expired',
};

export const WEBHOOK_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  FAILED: 'failed',
};

// Legacy support - can be removed when no longer used
export const WEBHOOK_EVENT_TYPES = {
  CONVERSION: 'conversion',
};
